import React from "react";
import { Container } from "react-bootstrap";
import { Redirect } from "react-router-dom";
import AddProductAssistantForm from "../../components/AddProductAssistantForm";
import useAuth from "../../contexts/auth";

export default function AddProductAssistantPage() {
  const { user } = useAuth();

  if (!user) return <Redirect to="/entrar" />;
  if (user.type !== "poster" && user.type !== "admin") {
    return <Redirect to="/" />;
  }

  return (
    <Container className="py-4">
      <AddProductAssistantForm />
    </Container>
  );
}
